function DateInput({ id, label, name, onChange, value, placeholder, requiredField = false, error, touched, ...rest }) {
  let validationClass = null;

  if (touched && error) {
    validationClass = 'is-invalid';
  } else if (touched && !error) {
    validationClass = 'is-valid';
  }

  return (
    <>
      <label htmlFor={ id } className="form-label">{ requiredField ? `${label}*` : label }</label>
      <input
        type="date"
        className={ [ 'form-control', validationClass ].join(' ') }
        placeholder={ placeholder }
        id={ id }
        name={ name }
        onChange={ onChange }
        value={ value }
        {...rest}/>
      {
        error ? (
          <div className="invalid-feedback">
            { error }
          </div>
        ) : null
      }
    </>
  );
}

export default DateInput;
